export default {
  methods: {
    loadFileInfos () {
      return this.$axios.api.get('paiement-paysafe/file-infos/')
    },

    sendProcessPayment(fileId, montant, paymentToken, ) {
      let payload = { 
        fileId: fileId, 
        montant: montant,
        paymentToken: paymentToken 
      }
      return this.$axios.api.post('paiement-paysafe/process-payment/', payload)
    }
  }
}